"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const Pen2D_1 = __importDefault(require("../../molecules/Pen2D"));
const Labels_1 = __importDefault(require("../../organisms/Labels"));
const Stickies_1 = __importDefault(require("../../organisms/Stickies"));
const providers_1 = require("../../providers");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const hooks_1 = require("../../hooks");
const initializeStickies_1 = __importDefault(require("./initializeStickies"));
const storage_1 = require("@completeanatomy/storage");
const device_1 = require("@completeanatomy/device");
const ui_1 = require("@completeanatomy/ui");
const react_router_dom_1 = require("react-router-dom");
const organisms_1 = require("../../organisms");
const STORAGE_KEY = 'firstLabelHintShown';
const DEFAULT_LABEL_WIDTH = 280;
// eslint-disable-next-line max-lines-per-function
function ToolsPage({ selectedToolType = bridge_schema_1.ToolType.None, selectedColor, selectedSize, setSelectedId, onDone, setSelectedType, isAddingLabels, trigger, guidesPanelDisable, hideLabelState, isStickyEditable = true, }) {
    const tools = (0, providers_1.useToolsService)();
    const stickies = (0, hooks_1.useStickiesState)();
    const penOptions = (0, hooks_1.usePenOptions)();
    const { hideAnnotations } = (0, hooks_1.useVisibilityState)();
    const { isMobile } = (0, device_1.usePlatform)();
    const isLandscape = (0, ui_1.useOrientation)();
    const labels = (0, hooks_1.useLabelState)();
    const storage = (0, storage_1.useStorageService)();
    const [{ guidesGridWidth }] = (0, providers_1.useGuidesContext)();
    const [searchParams, setSearchParams] = (0, react_router_dom_1.useSearchParams)();
    const addSticky = searchParams.get('addSticky') === 'true';
    const updateUndoRedoHistory = (0, react_1.useCallback)(() => {
        tools === null || tools === void 0 ? void 0 : tools.getStickiesToolManager().updateUndoRedoHistory();
    }, [tools]);
    const stickyPosition = stickies.map(sticky => {
        return sticky.stickyRect;
    });
    const labelPosition = labels.map(label => {
        return label.position;
    });
    const [shouldShowGuidesPanel, setShouldShowGuidesPanel] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (addSticky &&
            (selectedToolType === bridge_schema_1.ToolType.StickyText ||
                selectedToolType === bridge_schema_1.ToolType.StickyHandWriting)) {
            (0, initializeStickies_1.default)(selectedToolType, stickies, tools);
            updateUndoRedoHistory();
            searchParams.delete('addSticky');
            setSearchParams(searchParams, { replace: true });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        addSticky,
        selectedToolType,
        stickies,
        tools,
        updateUndoRedoHistory,
        searchParams,
        setSearchParams,
    ]);
    const [isMovingLabelOrSticky, setIsMovingLabelOrSticky] = (0, react_1.useState)(false);
    const prevLabelPositionsRef = (0, react_1.useRef)(labelPosition);
    const prevStickyPositionsRef = (0, react_1.useRef)(stickyPosition);
    (0, react_1.useEffect)(() => {
        if (selectedToolType !== bridge_schema_1.ToolType.None) {
            setShouldShowGuidesPanel(true);
            return;
        }
        const windowSize = { width: window.innerWidth, height: window.innerHeight };
        // Get current positions
        const currentLabelPositions = labels.map(label => ({
            x: label.position.x * windowSize.width,
            y: label.position.y * windowSize.height,
        }));
        const currentStickyPositions = stickies.map(sticky => sticky.stickyRect);
        // Track movement
        const labelsAreMoving = currentLabelPositions.some((label, index) => {
            var _a, _b;
            return label.x !== ((_a = prevLabelPositionsRef.current[index]) === null || _a === void 0 ? void 0 : _a.x) ||
                label.y !== ((_b = prevLabelPositionsRef.current[index]) === null || _b === void 0 ? void 0 : _b.y);
        });
        const stickiesAreMoving = currentStickyPositions.some((sticky, index) => {
            var _a, _b;
            return sticky.x !== ((_a = prevStickyPositionsRef.current[index]) === null || _a === void 0 ? void 0 : _a.x) ||
                sticky.y !== ((_b = prevStickyPositionsRef.current[index]) === null || _b === void 0 ? void 0 : _b.y);
        });
        const isCurrentlyMoving = labelsAreMoving || stickiesAreMoving;
        // Update movement state
        if (isMovingLabelOrSticky !== isCurrentlyMoving) {
            setIsMovingLabelOrSticky(isCurrentlyMoving);
        }
        // Update position refs only if actually moving
        if (isCurrentlyMoving) {
            prevLabelPositionsRef.current = [...currentLabelPositions];
            prevStickyPositionsRef.current = [...currentStickyPositions];
        }
        // Check danger zones only if actively moving
        const isLabelInDangerZone = isCurrentlyMoving &&
            currentLabelPositions.some(label => label.x < guidesGridWidth ||
                label.x + DEFAULT_LABEL_WIDTH > windowSize.width - guidesGridWidth);
        const isStickyInDangerZone = isCurrentlyMoving &&
            currentStickyPositions.some(sticky => sticky.x < guidesGridWidth ||
                sticky.x + sticky.width > windowSize.width - guidesGridWidth);
        // Show grid ONLY when actively moving in danger zone
        const shouldShowGrid = isCurrentlyMoving && (isLabelInDangerZone || isStickyInDangerZone);
        setShouldShowGuidesPanel(shouldShowGrid);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedToolType, labels, stickies, guidesGridWidth]);
    const checkAndShowHint = (0, react_1.useCallback)(() => __awaiter(this, void 0, void 0, function* () {
        if (!storage)
            return;
        const hintShown = yield storage.get(STORAGE_KEY);
        if (!hintShown) {
            //@ts-ignore
            window.helpView.showFirstLabelHint();
            storage.put(STORAGE_KEY, true);
        }
    }), [storage]);
    (0, react_1.useEffect)(() => {
        if (labels.length === 4) {
            checkAndShowHint();
        }
    }, [labels, checkAndShowHint]);
    return ((0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'ToolsPage_Container', children: [!guidesPanelDisable && shouldShowGuidesPanel && ((0, jsx_runtime_1.jsx)(organisms_1.GuidesPanel, { selectedToolType: selectedToolType || bridge_schema_1.ToolType.None, "data-e2e": 'ToolsPage_GuidesPanel' })), (!hideLabelState || (isMobile && !isLandscape)) && ((0, jsx_runtime_1.jsx)(Labels_1.default, { labels: labels, selectedToolType: selectedToolType, isAddingLabels: isAddingLabels, trigger: trigger, "data-e2e": 'ToolsPage_LabelsPanel' })), !hideAnnotations && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Pen2D_1.default, Object.assign({}, penOptions, { type: selectedToolType, "data-e2e": 'ToolsPage_Pen2D' })), !hideLabelState && ((0, jsx_runtime_1.jsx)(Stickies_1.default, { stickies: stickies, selectedColor: selectedColor, selectedSize: selectedSize, setSelectedID: setSelectedId, onDone: onDone, selectedToolType: selectedToolType, setSelectedType: setSelectedType, trigger: trigger, isEditable: isStickyEditable, "data-e2e": 'ToolsPage_StickiesPanel' }))] }))] }));
}
exports.default = (0, providers_1.withGuidesProvider)((0, storage_1.withStorageProvider)((0, react_1.memo)(ToolsPage)));
const Container = styled_components_1.default.div `
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;

  overflow: hidden;

  width: 100vw;
  height: 100vh;

  pointer-events: none;
`;
